<template>
  <section class="section-padding bg-gradient-to-r from-primary-600 to-purple-600">
    <div class="container-custom">
      <div class="text-center text-white">
        <h2 class="text-3xl md:text-5xl font-bold mb-6">
          Ready to Transform Your
          <span class="text-yellow-300">Project Management?</span>
        </h2>
        <p class="text-xl text-primary-100 mb-8 max-w-3xl mx-auto">
          Join thousands of teams who have already transformed their workflow with Task Manager Pro. 
          Get started today and see the difference.
        </p>
        
        <!-- CTA Buttons -->
        <div class="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <a href="https://tmp.softentra.com/wp-admin/admin.php?page=task-manager-pro" target="_blank" class="bg-white text-primary-600 hover:bg-gray-100 font-semibold py-4 px-8 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl text-lg">
            <i class="fas fa-rocket mr-2"></i>
            Live Demo
          </a>
          <a href="https://www.softentra.com/products/task-manager-pro-wordpress-project-management-plugin-with-time-tracking-team-collaboration" target="_blank" class="bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary-600 font-semibold py-4 px-8 rounded-lg transition-all duration-200 text-lg">
            <i class="fas fa-shopping-cart mr-2"></i>
            Buy Now
          </a>
        </div>
        
        <!-- Trust Indicators -->
        <div class="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div class="text-center">
            <div class="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i class="fas fa-shield-alt text-2xl"></i>
            </div>
            <h3 class="text-xl font-bold mb-2">30-Day Guarantee</h3>
            <p class="text-primary-100">Try risk-free with our money-back guarantee</p>
          </div>
          <div class="text-center">
            <div class="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i class="fas fa-headset text-2xl"></i>
            </div>
            <h3 class="text-xl font-bold mb-2">24/7 Support</h3>
            <p class="text-primary-100">Expert help whenever you need it</p>
          </div>
          <div class="text-center">
            <div class="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i class="fas fa-sync-alt text-2xl"></i>
            </div>
            <h3 class="text-xl font-bold mb-2">Regular Updates</h3>
            <p class="text-primary-100">Always improving with new features</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CTASection'
}
</script>
